


















import Vue from "vue";
import AdminService from "@/services/adminService";

export default Vue.extend({
  name: "UploadAgreement",

  data() {
    let tmp: any;
    return {
      file: tmp,
      uploading: false
    };
  },
  methods: {
    handleFileUpload(e) {
      this.file = e.target.files[0]
    },
    async submit(e) {
      this.uploading = true;
      e.preventDefault();
      const jwt = window.localStorage.getItem("jwt");
      if (jwt) {
        try {
          const formData = new FormData();
          formData.append("file", this.file);
          const adminService = new AdminService(jwt);
          const response = await adminService.uploadAgreements(formData);
          if (response && response.status == 200) {
            if (response.data) {
              this.uploading = false;
              alert("Upload Successfully");
              await this.$router.push("/admin-agreement");
            }
          }
        } catch (error) {
          this.uploading = false;
          alert(JSON.stringify(error.response.data));
        }
      }
    },
    async cancel() {
      await this.$router.push("/admin-agreement");
    }
  }
});
